{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversazioni selezionate",
    "NONE": "Nessuno",
    "CLEAR_SELECTION": "Rimuovi",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Sei sicuro di voler assegnare {n} conversazione a {agentName}? | Sei sicuro di voler assegnare {n} conversazioni a {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Sei sicuro di voler disassegnare {n} conversazione? | Sei sicuro di voler disassegnare {n} conversazioni?",
    "YES": "Sì",
    "CANCEL": "Annulla",
    "SEARCH_INPUT_PLACEHOLDER": "Cerca",
    "ASSIGN_AGENT_TOOLTIP": "Assegna operatore",
    "ASSIGN_TEAM_TOOLTIP": "Assegna team",
    "ASSIGN_SUCCESFUL": "Conversazioni assegnate correttamente.",
    "ASSIGN_FAILED": "Impossibile assegnare le conversazioni. Riprova.",
    "RESOLVE_SUCCESFUL": "Conversazioni risolte correttamente.",
    "RESOLVE_FAILED": "Impossibile risolvere le conversazioni. Riprova.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Solo le conversazioni visibili in questa pagina sono selezionate.",
    "UPDATE": {
      "CHANGE_STATUS": "Cambia stato",
      "SNOOZE_UNTIL": "Posticipa",
      "UPDATE_SUCCESFUL": "Stato della conversazione aggiornato correttamente.",
      "UPDATE_FAILED": "Impossibile aggiornare le conversazioni. Riprova."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Impossibile risolvere le conversazioni a causa di attributi richiesti mancanti",
      "PARTIAL_SUCCESS": "Alcune conversazioni necessitano di attributi richiesti per essere risolte, perciò sono state saltate"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assegna etichette",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Assegna etichette selezeionate",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Etichette assegnate correttamente.",
      "ASSIGN_FAILED": "Impossibile assegnare le etichette. Riprova.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Nessuno",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Sei sicuro di voler assegnare {n} conversazione a {teamName}? | Sei sicuro di voler assegnare {n} conversazioni a {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Sei sicuro di voler disassegnare {n} conversazione? | Sei sicuro di voler disassegnare {n} conversazioni?",
      "ASSIGN_SUCCESFUL": "Team assegnati con successo.",
      "ASSIGN_FAILED": "Impossibile assegnare il team. Riprova."
    }
  }
}
